import { AspectRatio, Image } from '@mantine/core'
import { Typography } from '../common/typography'
import classes from './Navigation.module.css'

export default function CompetitionDisplay({
  logo,
  name,
}: {
  logo: string
  name: string
}) {
  return (
    <div className={classes.competitionDisplay}>
      <AspectRatio ratio={1}>
        <Image
          className={classes.competitionDisplayLogo}
          src={logo}
          alt={name}
          fit="scale-down"
        />
      </AspectRatio>
      <Typography level={2} fs="lg" fw={500} lh="125">
        {name}
      </Typography>
      <div className={classes.newsDetails} />
    </div>
  )
}
